<template>
    <BTable
        small
        stacked
        :items="tableItems"
        :fields="tableFields"
        class="omni-table-small"
    >
        <template v-for="field in tableFields" v-slot:[`cell(${field.key})`]="data">
          <slot v-if="field.key === 'invoices'" :name="`cell(${field.key})`">
              <span v-for="(value, index) in data.value" :key="index">
                <a v-if="value.link" :href="value.link" target="_blank">{{ value.txt }}<br/></a>
                <span v-else>{{ value.txt }}<br/></span>
              </span>
          </slot>
          <slot v-else :name="`cell(${field.key})`" v-bind="data">
            {{ formatValue(data.item[field.key]) }}
          </slot>
        </template>
    </BTable>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        fields: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        tableFields() {
            return this.fields;
        },
        tableItems() {
            return this.items;
        },
        slotProps() {
            return {
                item: this.tableItems,
                field: this.tableFields,
            };
        },
    },
    methods: {
        formatValue(value) {
            if (Array.isArray(value)) {
                return value.join(", ")
            }
            return value
        }
    }
});
</script>

<style lang="scss">
.omni-table-small {
    $label-width: 45%;

    &.table.b-table.b-table-stacked>tbody>tr {
        > :first-child {
            border-top-width: 1px;
        }

        >td {
            padding: 0;
        }

        >[data-label] {
            > div {
                width: calc(100% - #{$label-width});
            }

            &::before {
                font-weight: bold;
                background-color: #f4f7fa;
                color: #404447;
                width: $label-width;
                text-align: left;
                height: 100%;
            }

            > div, &::before {
                padding: 0.25rem 0.5rem;
            }
        }
    }
}
</style>